import { Component, OnInit, ViewContainerRef, ElementRef, ViewChild } from '@angular/core';
import { Userclass } from '../Classes/Userclass';
import { CommonSearch } from '../Classes/CommonClass';
import { UserService } from '../Services/UserService';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../Services/CommonServices';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs';
import { Headers, Http, Response, RequestOptions } from '@angular/http';

@Component({
  selector: 'User-Search',
  templateUrl: '../Users/UserSearch.Component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/fixedheader.css'],
  providers: [UserService, CommonService]
})

export class UserSearchComponent implements OnInit {
  _User = new Userclass();
  _CommonSearch = new CommonSearch();
  innerWidth: number;
  loading: boolean = false;
  QueryTenantID: any = [];
  QueryMessage: any = [];
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  SearchdropFirst: any[] = [
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'Pname', Text: 'Org Name' },
    { Value: 'lettercode', Text: 'Org Code' },
    { Value: 'FirstName', Text: 'First Name' },
    { Value: 'LastName', Text: 'Last Name' },
    { Value: 'UserName', Text: 'Username' },
    { Value: 'Email', Text: 'Email' },
    { Value: 'Role', Text: 'Role' }
  ]
  SearchdropSecond: any[] = [
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'Pname', Text: 'Org Name' },
    { Value: 'lettercode', Text: 'Org Code' },
    { Value: 'FirstName', Text: 'First Name' },
    { Value: 'LastName', Text: 'Last Name' },
    { Value: 'UserName', Text: 'Username' },
    { Value: 'Email', Text: 'Email' },
    { Value: 'Role', Text: 'Role' }
  ]
  GetUserResult: any = [];
  @ViewChild("inputBox") _el: ElementRef;
  @ViewChild("inputBoxtext") _el1: ElementRef;
  RoleID: string;
  StateData: string;
  constructor(private _CommonService: CommonService,private _UserService: UserService, private _router: Router, private Activeroute: ActivatedRoute, public toastr: ToastsManager, vcr: ViewContainerRef,
    private http: Http) {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
  }
  ngOnInit() {
    this.ChangeHeadeFooterColor();
    this.RoleID = sessionStorage.getItem('RoleID');
    let val = localStorage.getItem('SearchtextFirst');
    let val2 = localStorage.getItem('SearchtextSecond');
    if (val != null || val2 != null) {
      this._UserService.Get_OrgDetails(val, val2).subscribe(res => {
        var data = res;
        if (!data.Message) {
          this.GetUserResult = data;
          this.loading = false;
        }
        else {
          this.toastr.error(data.Message);
          this.loading = false;
        }
      })
    }
    this._User.SearchdropFirst = "-1";
    this._User.SearchdropSecond = "-1";
    this._User.SearchMatchesFirst = "Contains";
    this._User.SearchMatchesSecond = "Contains";
  }

  public GetUserSearchAutocomplete = (SearchStr: any, SearchdropName: any): Observable<any[]> => {
    
    if (SearchStr) {
      let OrgDetails = { "mQuery": JSON.stringify(SearchdropName), "SearchDropName": JSON.stringify(SearchStr) };
      let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
      let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
      return this.http.get('api/Organization/GetOrgSearchAutocomplete', options)
        .map(res => {
          let json = res.json();
          let jsonarray = json;
          return jsonarray;
        })
    }
    else {
      return Observable.of([]);
    }
  }

  public GetOrgSearchAutocomplete = (SearchType: any, Searchstring: any): Observable<any[]> => {

    if (Searchstring) {
      this._CommonSearch.SearchType = SearchType;
      this._CommonSearch.Searchstring = Searchstring;
      let Result = this._CommonService.GetAutoCompleteResult(this._CommonSearch)
      return Result;
    }
    else {
      return Observable.of([]);
    }
  }
  public FilterFirstChange(Searchdrop: string) {
    this.SearchdropSecond = [];
    let SearchdropFirstdata: any[] = this._User.SearchdropSecondList;
    for (let i = 0; i < SearchdropFirstdata.length; i++) {
      if (SearchdropFirstdata[i].Value != Searchdrop) {
        this.SearchdropSecond.push(SearchdropFirstdata[i]);
      }
      else {
        this.SearchdropFirst.slice(i, 1);
      }
    }
    this._User.SearchtextFirst = "";
    this._User.SearchMatchesFirst = "Contains"; 
  }

  public FilterSecondChange(Searchdrop: string) {
    this.SearchdropFirst = [];
    let SearchdropSeconddata: any[] = this._User.SearchdropFirstList;
    for (let i = 0; i < SearchdropSeconddata.length; i++) {
      if (SearchdropSeconddata[i].Value != Searchdrop) {
        this.SearchdropFirst.push(SearchdropSeconddata[i]);
      }
      else {
        this.SearchdropSecond.slice(i, 1);
      }
    }
    this._User.SearchtextSecond = "";
    this._User.SearchMatchesSecond = "Contains"; 
  }

  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }


  public BtnSearch() {
    this.loading = true;
    var mQuery: string = "";
    if ((this._User.SearchdropFirst != "-1") || (this._User.SearchdropSecond != "-1")) {

      let pattern = new RegExp(/^[- a-z. 0-9 _ < > & $ % @ * ~ ! ^ + = : ; , | ( ) { } ? \/ ! # ]+$/i)
      var SearchFirst = true;
      var SearchSecond = true;
      SearchFirst = pattern.test(this._User.SearchtextFirst);
      SearchSecond = pattern.test(this._User.SearchtextSecond);

      /***********************First Drop Down ****************************************/
      
        if (this._User.SearchdropFirst != "-1") {
          if (this._User.SearchtextFirst != undefined && this._User.SearchtextFirst != "") {
            if (SearchFirst == true) {
              if (this._User.SearchMatchesFirst == "Contains") {

                mQuery = "where " + this._User.SearchdropFirst + ' like ' + "'%" + this._User.SearchtextFirst + "%'";
              }
              else if (this._User.SearchMatchesFirst == "Exact") {
                mQuery += "where " + this._User.SearchdropFirst + ' = ' + "'" + this._User.SearchtextFirst + "'";
              }
            }
            else {
              this.ShowWriteToastMessage();
              var SearchmessageFirst;
              SearchmessageFirst = this._User.SearchdropFirst
              if (this._User.SearchdropFirst == "LastName") {
                SearchmessageFirst = "Last Name";
              }
              else if (this._User.SearchdropFirst == "FirstName") {
                SearchmessageFirst = "First Name";
              }
              this.loading = false;
              this.toastr.error("Please enter valid characters in " + SearchmessageFirst + " search");
              this.SetRightToastMessage();
              return;
            }
          }
          else {
            /********* ShowWriteToastMessage ******/
            this.ShowWriteToastMessage();
            var SearchmessageFirst;
            SearchmessageFirst = this._User.SearchdropFirst
            if (this._User.SearchdropFirst == "LastName") {
              SearchmessageFirst = "Last Name";
            }
            else if (this._User.SearchdropFirst == "FirstName") {
              SearchmessageFirst = "First Name";
            }
            this.toastr.error('Please enter the ' + SearchmessageFirst + '.');
            this.loading = false;

            /********* SetRightToastMessage ******/
            this.SetRightToastMessage();
            return;
          }
        }

      /***********************Second Drop Down ****************************************/
      
        if (this._User.SearchdropSecond != "-1") {

          if (this._User.SearchtextSecond != undefined && this._User.SearchtextSecond != "") {
            if (SearchSecond == true) {
              if (!this._User.SearchtextFirst) {
                if (this._User.SearchMatchesSecond == "Contains") {
                  mQuery += "where " + this._User.SearchdropSecond + ' like ' + "'%" + this._User.SearchtextSecond + "%'";
                }
                else if (this._User.SearchMatchesSecond == "Exact") {
                  mQuery += "where " + this._User.SearchdropSecond + ' = ' + "'" + this._User.SearchtextSecond + "'";
                }

              }
              else {
                if (this._User.SearchdropSecond != "State") {
                  if (this._User.SearchMatchesSecond == "Contains") {
                    mQuery += "and " + this._User.SearchdropSecond + ' like ' + "'%" + this._User.SearchtextSecond + "%'";
                  }
                  else if (this._User.SearchMatchesSecond == "Exact") {
                    mQuery += "and " + this._User.SearchdropSecond + ' = ' + "'" + this._User.SearchtextSecond + "'";
                  }
                }
              }
            }
            else {
              this.ShowWriteToastMessage();
              var SearchmessageSecond;
              SearchmessageSecond = this._User.SearchdropSecond;
              if (this._User.SearchdropSecond == "LastName") {
                SearchmessageSecond = "Last Name"
              }
              else if (this._User.SearchdropSecond == "FirstName") {
                SearchmessageSecond = "First Name"
              }
                this.loading = false;
                this.toastr.error("Please enter valid characters in " + SearchmessageSecond + " search");
                this.SetRightToastMessage();
                return;
            }
          }
          else{
            /********* ShowWriteToastMessage ******/
            this.ShowWriteToastMessage();
            var SearchmessageSecond;
            SearchmessageSecond = this._User.SearchdropSecond;
            if (this._User.SearchdropSecond == "LastName") {
              SearchmessageSecond = "Last Name"
            }
            else if (this._User.SearchdropSecond == "FirstName") {
              SearchmessageSecond = "First Name"
            }
            this.toastr.error('Please enter the ' + SearchmessageSecond + '.');
            this.loading = false;
            /********* SetRightToastMessage ******/
            this.SetRightToastMessage();
            return;
          }
        }      
    }
    else {
      this.toastr.error('Please select at least one criteria.');
      this.loading = false;
      return;
    }
    console.log(mQuery);
    localStorage.setItem('SearchtextFirst', mQuery);
    var mQuerysecond = "";
    this._UserService.Get_OrgDetails(mQuery, mQuerysecond).subscribe(res => {
      var data = res;
      if (!data.Message) {
        this.GetUserResult = data;
        this.loading = false;
      }
      else {
        this.toastr.error(data.Message);
        this.loading = false;
      }
    })
  }
  ShowWriteToastMessage() {
    if (this._User.SearchdropFirst == "Pname") {
      this._User.SearchdropFirst = "Org Name";
    }
    else if (this._User.SearchdropFirst == "lettercode") {
      this._User.SearchdropFirst = "Org Code";
    }
    else if (this._User.SearchdropSecond == "Pname") {
      this._User.SearchdropSecond = "Org Name";
    }
    else if (this._User.SearchdropSecond == "lettercode") {
      this._User.SearchdropSecond = "Org Code";
    }
  }

  SetRightToastMessage() {
    if (this._User.SearchdropFirst == "Org Name") {
      this._User.SearchdropFirst = "Pname";
    }
    else if (this._User.SearchdropFirst == "Org Code") {
      this._User.SearchdropFirst = "lettercode";
    }
    else if (this._User.SearchdropSecond == "Org Name") {
      this._User.SearchdropSecond = "Pname";
    }
    else if (this._User.SearchdropSecond == "Org Code") {
      this._User.SearchdropSecond = "lettercode";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Users/UserSearch.Component.ts